import { render, staticRenderFns } from "./friendTokenError.vue?vue&type=template&id=7ee7a5c0&"
import script from "./friendTokenError.vue?vue&type=script&lang=js&"
export * from "./friendTokenError.vue?vue&type=script&lang=js&"
import style0 from "./friendTokenError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports